<template>

  <div class="menu-title">
    <p>Dumpling Dish</p>
  </div>


  <div class="dumpling-container-1">

    <div class="dumpling-grid-1">
      <div>
        <img class="menu-pic" src="../assets/DumplingDeepFried.jpg">
      </div>
      <div class="menu-text">
        <p>Deep Fried Dumpling</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>

    <div class="dumpling-grid-2">
      <div>
        <img class="menu-pic" src="../assets/DumplingPanFried.jpg">
      </div>
      <div class="menu-text">
        <p>Pan Fried Dumpling</p>
        <!-- <p>9.99</p> -->
      </div>
    </div>

    <div class="dumpling-grid-3">
      <div>
        <img class="menu-pic" src="../assets/DumplingSteamed.jpg">
      </div>
      <div class="menu-text">
        <p>Steamed Dumpling</p>
        <!-- <p>11.99 (10)</p> -->
      </div>
    </div> 

  </div>


  <div class="menu-detail">
    <p>Veggie (5)  </p>
    <p>Pork (5) </p>
    <p>Beef (5) </p>
    <p>Shrimp (5) </p>
    <p>Chicken (5) </p>
    <p>Turkey (5) </p>
  </div>

</template>


<script>

  export default {
    name: 'DumplingBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 3vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-bottom: 5vw;
    color: darkblue;
  }


  .dumpling-container-1 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
  }

  .menu-detail {
    text-align: left;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 1vw;
    margin-left: 7vw;
    color: darkblue;
  }


}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 5vw;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    color: darkblue;
  }


  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw;
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: -0.5vw;
  }

  .menu-detail {
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: 3rem;
    color: darkblue;
  }

}
  
</style>